import {Component, OnInit, OnDestroy,ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'app-escalate',
    templateUrl: './escalate.component.html',
    styleUrls: ['./escalate.component.css']
})
export class EscalateComponent implements OnInit, OnDestroy {

    displayed = true;
    name: string;
    dropdown: string;
    clientId: number;

    add = false;
    del = false;
    edit = false;
    view = false;

    displayData: any;

    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    types = [];
    private notifier: NotifierService;
    typeSelected: number;
    isDropdown: boolean;
    type: string;
    ttypes = [];
    categories = [];
    defaultValue: string;
    categorySelected: string;
    private category: any;
    groups = [];
    groupSelected: number;
    private groupName: string;
    escalated: any;
    priorities = [];
    prioritySelected: number;
    priority: any;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    private baseFlag: any;
    private userAuth: Subscription;
    offset: number;
    ticketSelected: number;
    ticketType: string;
    selectedSupportGroup: number;
    notification_subject: string;
    editorValue: string;
    notificationSelected: number;
    notificationType = [];
    escalatedSupportGroup = [];
    escalateWhen = [];
    escalate_given_time: any;
    slaAlert = [];
    selectEscalateWhen: number;
    selectSlaAlert: number;
    isHideSupportGroup: boolean;
    is_escalated_to_all_support_grp: string;
    slaGivenTime: any;
    allSupportGroupId = [];
    additionalEmail: string;
    escalationTime: string;
    dataLoaded: boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    catSelected: any;
    escalates: any;

    sGrp: string;
    dataArr: any;
    idd: number;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;
    resolutionTimeDetails:any;
    res:any;
    sgRes:any;
    isSupp:boolean;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            console.log(item);
                            item.user_id = this.messageService.getUserId();
                            this._rest.updateTicketNotificationMst(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteEscalation({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.messageService.SERVER_ERROR);
                            });
                        }
                    }
                    break;
            }
        });
    }


    ngOnInit() {
        this.dataLoaded = false;
        this.prioritySelected = 0;
        this.isHideSupportGroup = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: 'Maintain Escalation',
            openModalButton: 'Add Escalation',
            searchModalButton: 'Search',
            breadcrumb: 'Escalation',
            folderName: 'All Escalation',
            tabName: 'Escalation',
            exportBtn: 'Export to excel',

        };
        this.notificationType = [{id: 0, name: 'Select Notification Type'}, {id: 1, name: 'mail'}, {id: 2, name: 'whatsapp'}];
        this.notificationSelected = 0;

        this.escalatedSupportGroup = [{id: 1, name: 'All'}, {id: 2, name: 'individual'}];
        this.escalateWhen = [{id: 1, name: 'After'}, {id: 2, name: 'Before'}];
        this.slaAlert = [{id: 1, name: 'After'}, {id: 2, name: 'Before'}];
        this.typeSelected = 1;

        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', minWidth: 10, sortable: true, filterable: true},
            {
                id: 'ticketType', name: 'Ticket Type', field: 'ticketType', minWidth: 30, sortable: true, filterable: true
            },
            {
                id: 'category', name: 'Category', field: 'categoryName', sortable: true, filterable: true
            },
            {
                id: 'subject', name: 'subject', field: 'notification_subject', sortable: true, filterable: true
            },
            {
                id: 'escalation_when_type', name: 'Escalation when type', field: 'escalation_when_type', sortable: true, filterable: true
            },
            {
                id: 'escalation_time_to_calculate', name: 'Escalation Time', field: 'escalation_time_to_calculate', sortable: true,
                filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'sla_alert_type', name: 'Sla alert type', field: 'sla_alert_type', sortable: true, filterable: true
            },
            {
                id: 'sla_given_time',
                name: 'Sla given time',
                field: 'sla_given_time',
                sortable: true,
                filterable: true,
                cssClass: 'highlight',
                editor: {
                    model: CustomInputEditor,
                }
            },
            {
                id: 'supportGroup', name: 'Support Group', field: 'supportGroup', sortable: true, filterable: true
            },
            {
                id: 'priority', name: 'Priority', field: 'priority', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        // this.messageService.setGridWidth(1000);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getTicketType(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Ticket Type'});
                this.ttypes = this.respObject.details;
                this.ticketSelected = 0;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', JSON.stringify(err));
        });
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }


    exportToExcel() {
        this.isExportDisable = true;
        // console.log("okkk" +this.clientId);
        this._rest.getAllEscalation(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;
                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }


    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.ticketSelected = 0;
            this.typeSelected = 1;
            this.escalated = '';
            this.groupSelected = 0;
            this.categorySelected = '0';
            this.prioritySelected = 0;
            this.notificationSelected = 0;
            this.notification_subject = '';
            this.additionalEmail = '';
            this.editorValue = '';
            this.escalate_given_time = '';
            this.slaGivenTime = '';
            this.escalationTime = '';
            this.res = '';
            this.sgRes = '';
            this.isSupp = false;
            this.modalService.open(content).result.then((result) => {
            }, (reason) => {

            });
        }
    }


    searchModal() {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.ticketSelected = 0;
            this.typeSelected = 1;
            this.escalated = '';
            this.groupSelected = 0;
            this.categorySelected = '0';
            this.prioritySelected = 0;
            this.notificationSelected = 0;
            this.notification_subject = '';
            this.additionalEmail = '';
            this.editorValue = '';
            this.escalate_given_time = '';
            this.slaGivenTime = '';
            this.escalationTime = '';
            this.sGrp = '';
            this.catSelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }


    search() {
        this._rest.searchAllStasearchAllEscalationtus( this.catSelected, this.clientId).subscribe((res1) => {
            this.respObject = res1;
            this.isLoading = false;
            if (this.respObject.success) {
                this.escalates = this.respObject.details;
                this.messageService.setTotalData(this.escalates.length);
                this.messageService.setGridData(this.escalates);
                this.searchModalReference.close();

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.isLoading = false;
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    save() {
        const data = {
            clientId: this.clientId,
            ticket_type_id: this.ticketSelected, notification_type: this.notificationSelected,
            notification_subject: this.notification_subject,
            notification_body: this.editorValue, is_escalated_to_all_support_grp: this.is_escalated_to_all_support_grp,
            escalated_to_support_grp: this.allSupportGroupId, escalation_when_type: this.selectEscalateWhen,
            escalation_time_to_calculate: Number(this.escalate_given_time), sla_alert_type: this.selectSlaAlert,
            sla_given_time: Number(this.slaGivenTime), createdBy: this.messageService.getUserId(), escalation_time: this.escalationTime,
            priority: this.prioritySelected
        };

        if (this.categorySelected === '-1') {
            this.categories.splice(0, 2);
            data['category_id'] = this.categories;
        } else {
            this.categories = [];
            let cat = {};
            cat['id'] = this.categorySelected;
            this.categories.push(cat);
            data['category_id'] = this.categories;
        }

        if (!this.messageService.isBlankField(data)) {
            data['additionalEmail'] = this.additionalEmail;
            // console.log('save data===', data);
            this._rest.insertEscalation(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.escalated = '';
                    this.groupSelected = 0;
                    this.categorySelected = '0';
                    this.prioritySelected = 0;
                    this.notificationSelected = 0;
                    this.notification_subject = '';
                    this.additionalEmail = '';
                    this.editorValue = '';
                    this.escalate_given_time = '';
                    this.slaGivenTime = '';
                    this.ticketSelected = 0;
                    this.escalationTime = '';
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded = false;
        this._rest.getEscalateDetails(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

    onTicketChange(selectedIndex: any) {
        this.ticketType = this.ttypes[selectedIndex].name;
        this._rest.getCategoryByTicketTypeNDynamicLevel(this.clientId, this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Category'}, {id: -1, name: 'Select All'});
                this.categories = this.respObject.details;
                this.categorySelected = '0';
            } else {
                this.categories = [];
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

        this._rest.getBusinessPriorityTicketTypeWise(this.clientId, this.ticketSelected).subscribe((res2) => {
            this.respObject = res2;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Priorities'});
                this.priorities = this.respObject.details;
                this.prioritySelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onCategoryChange(selectedIndex) {
        this.category = this.categories[selectedIndex].name;
        this._rest.getSupportGroupByCategory(this.clientId, this.categorySelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.details.unshift({id: 0, name: 'Select Support Group'});
                this.groups = this.respObject.details;
                console.log('groups===========', JSON.stringify(this.groups));
                this.groupSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onPriorityChange(selectedIndex) {
        this.priority = this.priorities[selectedIndex].name;
        this._rest.getResolutionTime(this.clientId , this.prioritySelected , this.ticketSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                // this.respObject.details.unshift({id: 0, name: 'Select support group'});
                this.resolutionTimeDetails = this.respObject.details;
                // let x = this.respObject.details;
                console.log(JSON.stringify(this.resolutionTimeDetails));

                this._rest.getSubClient(this.clientId).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        const sub_client = this.respObject.details[0].sub_client;
                        // console.log(JSON.stringify(k));
        
                        // console.log("-------------"+this.resolutionTimeDetails[0].RESOLUTIONTIME)
                        if (sub_client === 1) {
                            console.log("1");
                            if(this.resolutionTimeDetails.length > 1){
                                if(Number(this.resolutionTimeDetails[0].RESOLUTIONTIME) === Number(this.resolutionTimeDetails[1].RESOLUTIONTIME)){
                                    this.res = this.resolutionTimeDetails[0].RESOLUTIONTIME;
                                    this.isSupp = false;
                                }else{
                                    console.log("okkkkk");
                                    this.res = this.resolutionTimeDetails[0].RESOLUTIONTIME;
                                    this.sgRes = this.resolutionTimeDetails[1].RESOLUTIONTIME;
                                    this.isSupp = true;
                                }
                            }else{
                                this.res = this.resolutionTimeDetails[0].RESOLUTIONTIME;
                                this.isSupp = false;
                            }
                        }else{
                            this.res = this.resolutionTimeDetails[0].RESOLUTIONTIME;
                            console.log("0" + this.res);

                            this.isSupp = false;
                        }
                        
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
        

            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });


    }



    onGroupChange(selectedIndex: any) {
        this.groupName = this.groups[selectedIndex].name;
        this.allSupportGroupId = [];
        if (this.is_escalated_to_all_support_grp === 'N') {
            this.allSupportGroupId.push(this.groupSelected);
        }
    }

    onEscalateSupportGroupChecked(value) {
        this.selectedSupportGroup = value.value;
        this.allSupportGroupId = [];
        this.groupSelected = 0;
        if (this.selectedSupportGroup === 1) {
            this.is_escalated_to_all_support_grp = 'Y';
            this.isHideSupportGroup = true;
            for (let i = 0; i < this.groups.length; i++) {
                this.allSupportGroupId.push(this.groups[i].id);
            }
            // console.log('allSupportGroupId========', this.allSupportGroupId);
        } else {
            this.is_escalated_to_all_support_grp = 'N';
            this.isHideSupportGroup = false;
        }
    }

    onEscalateTimeChangeChange(value) {
        this.selectEscalateWhen = value.value;
    }

    onSlaAlertChange(value) {
        this.selectSlaAlert = value.value;
    }
}
